<ng-container *ngIf="visible">
  <ng-container *ngIf="element?.isField()">
    <app-field [field]="element" [layout]="layout"></app-field>
  </ng-container>
  <ng-container *ngIf="element?.isAction() && element.customAttributes?.location === 'BODY'">
    <app-action [action]="element"></app-action>
  </ng-container>
  <ng-container *ngIf="element?.isTable()">
    <app-table [table]="element" [visibleRecords]="element.visibleRecords" [waiting]="element.waiting"></app-table>
  </ng-container>
</ng-container>
